import { observable } from 'mobx';
import { IInstance } from '../../../interfaces/IInstance';
import { IUserPermission } from '../../../interfaces/IUserPermission';
import { IAccordion } from '../../../interfaces/IAccordion';
import { UniquePermissionsResult } from '../../../interfaces/UniquePermissionsResult';

export class PermissionsStore {

  ////////////////////////////////// Component properties //////////////////////////////////

  @observable public environment: "Development" | "Test" | "Production";
  @observable public token: string;
  @observable public tenant: string;
  @observable public highlightColor: string;
  @observable public marginTop: number;


  ////////////////////////////////////// Applications /////////////////////////////////////

  public ADMIN = "Admin";
  public MOBILE_APP = "AppAdmin";
  public EVENTS = "Events";
  public NAVIGATOR = "Navigator";
  public INFOSCREEN = "Infoscreen";
  public TOOLBOX = "Toolbox";
  public MESSAGES = "Messages";
  public CONTENT_CREATOR = "ContentCreator";
  public CONTENT_ORGANIZER = "ContentOrganizer";

  ////////////////////////////////////// Permissions //////////////////////////////////////

  // Admin
  @observable public adminHasPermissions: UniquePermissionsResult;
  // Mobile app
  @observable public mobileAppHasPermissions: UniquePermissionsResult;
  @observable public mobileAppInstances: IInstance[] = [];
  // Events
  @observable public eventsHasPermissions: UniquePermissionsResult;
  @observable public eventInstances: IInstance[] = [];
  // Navigator
  @observable public navigatorHasPermissions: UniquePermissionsResult;
  @observable public navigatorInstances: IInstance[] = [];
  // Infoscreen
  @observable public infoscreenHasPermissions: UniquePermissionsResult;
  // Toolbox
  @observable public toolboxHasPermissions: UniquePermissionsResult;
  // Messages
  @observable public messagesHasPermissions: UniquePermissionsResult;
  @observable public messagesInstances: IInstance[] = [];
  // ContentCreator
  @observable public contentCreatorHasPermissions: UniquePermissionsResult;
  @observable public contentCreatorInstances: IInstance[] = [];
  // ContentCreator
  @observable public contentOrganizerHasPermissions: UniquePermissionsResult;
  @observable public contentOrganizerInstances: IInstance[] = [];


  ////////////////////////////////////// Permissions //////////////////////////////////////

  @observable public selectedApplication: string;
  @observable public selectedInstance: IInstance;
  @observable public permissions: IUserPermission[];
  @observable public permissionItems: IAccordion[];
  @observable public userToAdd: IUserPermission;

  @observable public loading: boolean;

}